import { addDays, isAfter, isBefore } from 'date-fns';
import { TransactionChargeDto } from '@tiendanube/common';
import { PAYMENTS_MERCHANT_CHARGES_TAG } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { useNuvemPagoRedirect } from '../useNuvemPagoRedirect';

export interface Result {
  shouldShowMerchantCharges: () => boolean;
  isMerchantChargeInProgress: () => boolean;
}

// TODO: these constants are provisional and can be removed once the launch date
// for Pago Nube merchant charges is set and at least 2 days have passed since then
const pnMerchantChargesLaunchDate = new Date('2025-04-01T00:00:00Z');
const daysToWaitForMerchantCharge = 2;

function useShowMerchantCharges(
  merchantCharges?: TransactionChargeDto[],
  gateway?: string,
  paymentCreationDate?: string,
): Result {
  const [hasMerchantChargesTag] = useHasTags(PAYMENTS_MERCHANT_CHARGES_TAG);
  const { isNuvemPagoPayment } = useNuvemPagoRedirect(gateway ?? '');
  return {
    shouldShowMerchantCharges: () =>
      hasMerchantChargesTag && isNuvemPagoPayment(),
    isMerchantChargeInProgress: () =>
      isMerchantChargeInProgress(merchantCharges, gateway, paymentCreationDate),
  };
}

function isMerchantChargeInProgress(
  merchantCharges?: TransactionChargeDto[],
  gateway?: string,
  paymentCreationDate?: string,
): boolean {
  if (gateway !== 'Pago Nube') {
    return false;
  }
  const isWaitingForMerchantCharge: boolean = paymentCreationDate
    ? isBefore(
        new Date(),
        addDays(new Date(paymentCreationDate), daysToWaitForMerchantCharge),
      )
    : false;

  // TODO: The following constant can be removed once the launch date for Pago Nube merchant charges is set
  // and the 2-day waiting period (value of daysToWaitForMerchantCharge) has passed
  const isPNReadyForMerchantCharge: boolean = isAfter(
    new Date(),
    pnMerchantChargesLaunchDate,
  );
  return (
    (merchantCharges?.length ?? 0) === 0 &&
    isWaitingForMerchantCharge &&
    isPNReadyForMerchantCharge
  );
}

export default useShowMerchantCharges;
